__turbopack_context__.v({
  "firstScreenAnimText": "MainScreen-module-scss-module__p-lH0G__firstScreenAnimText",
  "firstScreenBackground": "MainScreen-module-scss-module__p-lH0G__firstScreenBackground",
  "firstScreenBoxText": "MainScreen-module-scss-module__p-lH0G__firstScreenBoxText",
  "firstScreenContainer": "MainScreen-module-scss-module__p-lH0G__firstScreenContainer",
  "firstScreenGradient": "MainScreen-module-scss-module__p-lH0G__firstScreenGradient",
  "firstScreenSvg": "MainScreen-module-scss-module__p-lH0G__firstScreenSvg",
  "firstScreenSvgText": "MainScreen-module-scss-module__p-lH0G__firstScreenSvgText",
  "firstScreenText": "MainScreen-module-scss-module__p-lH0G__firstScreenText",
  "firstScreenTitle": "MainScreen-module-scss-module__p-lH0G__firstScreenTitle",
  "svgClass": "MainScreen-module-scss-module__p-lH0G__svgClass",
  "svgTextClass": "MainScreen-module-scss-module__p-lH0G__svgTextClass",
});
